import { Iterable, List } from "immutable"
import moment = require("moment")
import * as React from "react"
import { slugify } from "../../custom_utils/helpers"
import { ApiResult, errorText, getActivities, noResultsText } from "../../custom_api/api"
import { emptyOpt, makeOpt } from "../../custom_utils/option"
import { ActivitySummaryProps } from "./activity_summary"
import { LinkButton } from "./library/button"
import { Block } from "./library/container"
import { trackActivityClick as trackClusterActivityClick } from "./library/tracking"
import { TippedActivitySummary } from "./tipped_activity_summary"

export type ActivitySummaryWithFirstDateProps = ActivitySummaryProps & { date: Date }

export interface TippedActivitiesBlockProps {
  readonly kind: "tipped_activities"
  readonly title: string
  readonly content: string
  readonly linkTitle: string
  readonly linkUrl: string
  readonly row_count: number
}

export type TippedActivitiesBlockState = {
  activitySummaries: ApiResult<List<ActivitySummaryWithFirstDateProps>>
}

export class TippedActivitiesBlock extends React.Component<TippedActivitiesBlockProps, TippedActivitiesBlockState> {
  constructor(props: TippedActivitiesBlockProps) {
    super(props)

    this.state = {
      activitySummaries: "loading",
    }
  }

  componentDidMount() {
    const startOfToday = moment().startOf('day').add(-1 , 'ms').toDate()

    getActivities({
      cluster: emptyOpt(),
      activity: emptyOpt(),
      edition: emptyOpt(),
      location: emptyOpt(),
      region: emptyOpt(),
      event: makeOpt(q => q.Where(e => e.Date.IsAfter(startOfToday)))
    },
    firstDate
    ).then(res => {
      if (res != "error" && res !== "loading") {
        this.setState(s => ({
          ...s,
          // the use of `firstDate` above guarantees that we can do the following cast
          activitySummaries: res.take(3).toList() as ApiResult<List<ActivitySummaryWithFirstDateProps>>,
        }))
      }
    })
  }

  render() {
    const p = this.props
    const s = this.state

    return (
      <Block>
        <div className="block block--tips">
          <div className="block__inner">
            <header className="block__header">
              <h2 data-anchor={slugify(p.title)} className="block__title title--m">{p.title}</h2>
              <div className="block__intro text--styled" dangerouslySetInnerHTML={{ __html: p.content }} />
              <LinkButton route={p.linkUrl}>{p.linkTitle}</LinkButton>
            </header>

            <div className="block__content">
              {
                s.activitySummaries == 'loading' ? <></> :
                s.activitySummaries == 'error' ? errorText :
                s.activitySummaries.isEmpty() ? noResultsText :
                  <ul className="row teasers">
                    {s.activitySummaries.map((s, i) => (
                      <TippedActivitySummary
                        key={`activity-summary-${i}`}
                        headingLevel="h3"
                        title={s.title}
                        date={s.date}
                        imageAlt={s.imageAlt}
                        imageUrl={s.imageUrl}
                        subtitle={s.subtitle}
                        location={s.location}
                        route={s.route}
                        onClick={() => trackClusterActivityClick(s.title, p.title)}
                        isTip={s.isTip}
                        row_count={p.row_count}
                      />
                    ))}
                  </ul>
              }
            </div>
          </div>          
        </div>
      </Block>
    )
  }
}

export const firstDate = (dates: Iterable<number, Date>): Date => dates.first()